export const CALI_TEXT_NUMBERS = [
  {
    atLeast: 1,
    notOver: 50,
    credits: [2, 7, 9, 10],
  },
  {
    atLeast: 51,
    notOver: 100,
    credits: [5, 22, 26, 29],
  },
  {
    atLeast: 101,
    notOver: 150,
    credits: [8, 36, 43, 48],
  },
  {
    atLeast: 151,
    notOver: 200,
    credits: [11, 51, 60, 67],
  },
  {
    atLeast: 201,
    notOver: 250,
    credits: [15, 65, 77, 86],
  },
  {
    atLeast: 251,
    notOver: 300,
    credits: [18, 80, 94, 105],
  },
  {
    atLeast: 301,
    notOver: 350,
    credits: [21, 94, 111, 125],
  },
  {
    atLeast: 351,
    notOver: 400,
    credits: [24, 109, 128, 144],
  },
  {
    atLeast: 401,
    notOver: 450,
    credits: [28, 123, 145, 163],
  },
  {
    atLeast: 451,
    notOver: 500,
    credits: [31, 137, 162, 182],
  },
  {
    atLeast: 501,
    notOver: 550,
    credits: [34, 152, 179, 201],
  },
  {
    atLeast: 551,
    notOver: 600,
    credits: [37, 166, 196, 220],
  },
  {
    atLeast: 601,
    notOver: 650,
    credits: [41, 181, 213, 239],
  },
  {
    atLeast: 651,
    notOver: 700,
    credits: [44, 195, 230, 258],
  },
  {
    atLeast: 701,
    notOver: 750,
    credits: [47, 210, 247, 278],
  },
  {
    atLeast: 751,
    notOver: 800,
    credits: [50, 224, 264, 297],
  },
  {
    atLeast: 801,
    notOver: 850,
    credits: [54, 239, 281, 316],
  },
  {
    atLeast: 851,
    notOver: 900,
    credits: [57, 253, 298, 335],
  },
  {
    atLeast: 901,
    notOver: 950,
    credits: [60, 267, 315, 354],
  },
  {
    atLeast: 951,
    notOver: 1000,
    credits: [63, 282, 332, 373],
  },
  {
    atLeast: 1001,
    notOver: 1050,
    credits: [67, 296, 349, 392],
  },
  {
    atLeast: 1051,
    notOver: 1100,
    credits: [70, 311, 366, 411],
  },
  {
    atLeast: 1101,
    notOver: 1150,
    credits: [73, 325, 383, 431],
  },
  {
    atLeast: 1151,
    notOver: 1200,
    credits: [76, 340, 400, 450],
  },
  {
    atLeast: 1201,
    notOver: 1250,
    credits: [80, 354, 417, 469],
  },
  {
    atLeast: 1251,
    notOver: 1300,
    credits: [83, 369, 434, 488],
  },
  {
    atLeast: 1301,
    notOver: 1350,
    credits: [86, 383, 451, 507],
  },
  {
    atLeast: 1351,
    notOver: 1400,
    credits: [89, 398, 468, 526],
  },
  {
    atLeast: 1401,
    notOver: 1450,
    credits: [93, 412, 485, 545],
  },
  {
    atLeast: 1451,
    notOver: 1500,
    credits: [96, 426, 502, 564],
  },
  {
    atLeast: 1501,
    notOver: 1550,
    credits: [99, 441, 519, 584],
  },
  {
    atLeast: 1551,
    notOver: 1600,
    credits: [102, 455, 536, 603],
  },
  {
    atLeast: 1601,
    notOver: 1650,
    credits: [106, 470, 553, 622],
  },
  {
    atLeast: 1651,
    notOver: 1700,
    credits: [109, 484, 570, 641],
  },
  {
    atLeast: 1701,
    notOver: 1750,
    credits: [112, 499, 587, 660],
  },
  {
    atLeast: 1751,
    notOver: 1800,
    credits: [115, 513, 604, 679],
  },
  {
    atLeast: 1801,
    notOver: 1850,
    credits: [119, 528, 621, 698],
  },
  {
    atLeast: 1851,
    notOver: 1900,
    credits: [122, 542, 638, 717],
  },
  {
    atLeast: 1901,
    notOver: 1950,
    credits: [125, 556, 655, 737],
  },
  {
    atLeast: 1951,
    notOver: 2000,
    credits: [128, 571, 672, 756],
  },
  {
    atLeast: 2001,
    notOver: 2050,
    credits: [132, 585, 689, 775],
  },
  {
    atLeast: 2051,
    notOver: 2100,
    credits: [135, 600, 706, 794],
  },
  {
    atLeast: 2101,
    notOver: 2150,
    credits: [138, 614, 723, 813],
  },
  {
    atLeast: 2151,
    notOver: 2200,
    credits: [141, 629, 740, 832],
  },
  {
    atLeast: 2201,
    notOver: 2250,
    credits: [145, 643, 757, 851],
  },
  {
    atLeast: 2251,
    notOver: 2300,
    credits: [148, 658, 774, 870],
  },
  {
    atLeast: 2301,
    notOver: 2350,
    credits: [151, 672, 791, 890],
  },
  {
    atLeast: 2351,
    notOver: 2400,
    credits: [154, 687, 808, 909],
  },
  {
    atLeast: 2401,
    notOver: 2450,
    credits: [158, 701, 825, 928],
  },
  {
    atLeast: 2451,
    notOver: 2500,
    credits: [161, 715, 842, 947],
  },
  {
    atLeast: 2501,
    notOver: 2550,
    credits: [164, 730, 859, 966],
  },
  {
    atLeast: 2551,
    notOver: 2600,
    credits: [167, 744, 876, 985],
  },
  {
    atLeast: 2601,
    notOver: 2650,
    credits: [171, 759, 893, 1004],
  },
  {
    atLeast: 2651,
    notOver: 2700,
    credits: [174, 773, 910, 1023],
  },
  {
    atLeast: 2701,
    notOver: 2750,
    credits: [177, 788, 927, 1043],
  },
  {
    atLeast: 2751,
    notOver: 2800,
    credits: [180, 802, 944, 1062],
  },
  {
    atLeast: 2801,
    notOver: 2850,
    credits: [184, 817, 961, 1081],
  },
  {
    atLeast: 2851,
    notOver: 2900,
    credits: [187, 831, 978, 1100],
  },
  {
    atLeast: 2901,
    notOver: 2950,
    credits: [190, 845, 995, 1119],
  },
  {
    atLeast: 2951,
    notOver: 3000,
    credits: [193, 860, 1012, 1138],
  },
  {
    atLeast: 3001,
    notOver: 3050,
    credits: [197, 874, 1029, 1157],
  },
  {
    atLeast: 3051,
    notOver: 3100,
    credits: [200, 889, 1046, 1176],
  },
  {
    atLeast: 3101,
    notOver: 3150,
    credits: [203, 903, 1063, 1196],
  },
  {
    atLeast: 3151,
    notOver: 3200,
    credits: [206, 918, 1080, 1215],
  },
  {
    atLeast: 3201,
    notOver: 3250,
    credits: [210, 932, 1097, 1234],
  },
  {
    atLeast: 3251,
    notOver: 3300,
    credits: [213, 947, 1114, 1253],
  },
  {
    atLeast: 3301,
    notOver: 3350,
    credits: [216, 961, 1131, 1272],
  },
  {
    atLeast: 3351,
    notOver: 3400,
    credits: [219, 976, 1148, 1291],
  },
  {
    atLeast: 3401,
    notOver: 3450,
    credits: [223, 990, 1165, 1310],
  },
  {
    atLeast: 3451,
    notOver: 3500,
    credits: [226, 1004, 1182, 1329],
  },
  {
    atLeast: 3501,
    notOver: 3550,
    credits: [229, 1019, 1199, 1349],
  },
  {
    atLeast: 3551,
    notOver: 3600,
    credits: [232, 1033, 1216, 1368],
  },
  {
    atLeast: 3601,
    notOver: 3650,
    credits: [236, 1048, 1233, 1387],
  },
  {
    atLeast: 3651,
    notOver: 3700,
    credits: [239, 1062, 1250, 1406],
  },
  {
    atLeast: 3701,
    notOver: 3750,
    credits: [242, 1077, 1267, 1425],
  },
  {
    atLeast: 3751,
    notOver: 3800,
    credits: [246, 1091, 1284, 1444],
  },
  {
    atLeast: 3801,
    notOver: 3850,
    credits: [249, 1106, 1301, 1463],
  },
  {
    atLeast: 3851,
    notOver: 3900,
    credits: [252, 1120, 1318, 1482],
  },
  {
    atLeast: 3901,
    notOver: 3950,
    credits: [255, 1134, 1335, 1502],
  },
  {
    atLeast: 3951,
    notOver: 4000,
    credits: [259, 1149, 1352, 1521],
  },
  {
    atLeast: 4001,
    notOver: 4050,
    credits: [262, 1163, 1369, 1540],
  },
  {
    atLeast: 4051,
    notOver: 4100,
    credits: [265, 1178, 1386, 1559],
  },
  {
    atLeast: 4101,
    notOver: 4150,
    credits: [268, 1192, 1403, 1578],
  },
  {
    atLeast: 4151,
    notOver: 4200,
    credits: [272, 1207, 1420, 1597],
  },
  {
    atLeast: 4201,
    notOver: 4250,
    credits: [275, 1221, 1437, 1616],
  },
  {
    atLeast: 4251,
    notOver: 4300,
    credits: [278, 1236, 1454, 1635],
  },
  {
    atLeast: 4301,
    notOver: 4350,
    credits: [281, 1250, 1471, 1655],
  },
  {
    atLeast: 4351,
    notOver: 4400,
    credits: [285, 1265, 1488, 1674],
  },
  {
    atLeast: 4401,
    notOver: 4450,
    credits: [288, 1279, 1505, 1693],
  },
  {
    atLeast: 4451,
    notOver: 4500,
    credits: [291, 1293, 1522, 1712],
  },
  {
    atLeast: 4501,
    notOver: 4550,
    credits: [294, 1308, 1539, 1731],
  },
  {
    atLeast: 4551,
    notOver: 4600,
    credits: [298, 1322, 1556, 1750],
  },
  {
    atLeast: 4601,
    notOver: 4650,
    credits: [301, 1337, 1573, 1769],
  },
  {
    atLeast: 4651,
    notOver: 4700,
    credits: [302, 1351, 1590, 1788],
  },
  {
    atLeast: 4701,
    notOver: 4750,
    credits: [299, 1366, 1607, 1808],
  },
  {
    atLeast: 4751,
    notOver: 4800,
    credits: [296, 1380, 1624, 1827],
  },
  {
    atLeast: 4801,
    notOver: 4850,
    credits: [292, 1395, 1641, 1846],
  },
  {
    atLeast: 4851,
    notOver: 4900,
    credits: [289, 1409, 1658, 1865],
  },
  {
    atLeast: 4901,
    notOver: 4950,
    credits: [286, 1423, 1675, 1884],
  },
  {
    atLeast: 4951,
    notOver: 5000,
    credits: [283, 1438, 1692, 1903],
  },
  {
    atLeast: 5001,
    notOver: 5050,
    credits: [279, 1452, 1709, 1922],
  },
  {
    atLeast: 5051,
    notOver: 5100,
    credits: [276, 1467, 1726, 1941],
  },
  {
    atLeast: 5101,
    notOver: 5150,
    credits: [273, 1481, 1743, 1961],
  },
  {
    atLeast: 5151,
    notOver: 5200,
    credits: [270, 1496, 1760, 1980],
  },
  {
    atLeast: 5201,
    notOver: 5250,
    credits: [266, 1510, 1777, 1999],
  },
  {
    atLeast: 5251,
    notOver: 5300,
    credits: [263, 1525, 1794, 2018],
  },
  {
    atLeast: 5301,
    notOver: 5350,
    credits: [260, 1539, 1811, 2037],
  },
  {
    atLeast: 5351,
    notOver: 5400,
    credits: [257, 1554, 1828, 2056],
  },
  {
    atLeast: 5401,
    notOver: 5450,
    credits: [253, 1568, 1845, 2075],
  },
  {
    atLeast: 5451,
    notOver: 5500,
    credits: [252, 1582, 1862, 2094],
  },
  {
    atLeast: 5501,
    notOver: 5550,
    credits: [252, 1597, 1879, 2114],
  },
  {
    atLeast: 5551,
    notOver: 5600,
    credits: [251, 1611, 1896, 2133],
  },
  {
    atLeast: 5601,
    notOver: 5650,
    credits: [251, 1626, 1913, 2152],
  },
  {
    atLeast: 5651,
    notOver: 5700,
    credits: [250, 1640, 1930, 2171],
  },
  {
    atLeast: 5701,
    notOver: 5750,
    credits: [250, 1655, 1947, 2190],
  },
  {
    atLeast: 5751,
    notOver: 5800,
    credits: [250, 1669, 1964, 2209],
  },
  {
    atLeast: 5801,
    notOver: 5850,
    credits: [249, 1684, 1981, 2228],
  },
  {
    atLeast: 5851,
    notOver: 5900,
    credits: [249, 1698, 1998, 2247],
  },
  {
    atLeast: 5901,
    notOver: 5950,
    credits: [248, 1712, 2015, 2267],
  },
  {
    atLeast: 5951,
    notOver: 6000,
    credits: [248, 1727, 2032, 2286],
  },
  {
    atLeast: 6001,
    notOver: 6050,
    credits: [247, 1741, 2049, 2305],
  },
  {
    atLeast: 6051,
    notOver: 6100,
    credits: [247, 1756, 2066, 2324],
  },
  {
    atLeast: 6101,
    notOver: 6150,
    credits: [246, 1770, 2083, 2343],
  },
  {
    atLeast: 6151,
    notOver: 6200,
    credits: [246, 1785, 2100, 2362],
  },
  {
    atLeast: 6201,
    notOver: 6250,
    credits: [245, 1799, 2117, 2381],
  },
  {
    atLeast: 6251,
    notOver: 6300,
    credits: [245, 1814, 2134, 2400],
  },
  {
    atLeast: 6301,
    notOver: 6350,
    credits: [244, 1828, 2151, 2420],
  },
  {
    atLeast: 6351,
    notOver: 6400,
    credits: [244, 1843, 2168, 2439],
  },
  {
    atLeast: 6401,
    notOver: 6450,
    credits: [244, 1857, 2185, 2458],
  },
  {
    atLeast: 6451,
    notOver: 6500,
    credits: [243, 1871, 2202, 2477],
  },
  {
    atLeast: 6501,
    notOver: 6550,
    credits: [243, 1886, 2219, 2496],
  },
  {
    atLeast: 6551,
    notOver: 6600,
    credits: [242, 1900, 2236, 2515],
  },
  {
    atLeast: 6601,
    notOver: 6650,
    credits: [242, 1915, 2253, 2534],
  },
  {
    atLeast: 6651,
    notOver: 6700,
    credits: [241, 1929, 2270, 2553],
  },
  {
    atLeast: 6701,
    notOver: 6750,
    credits: [241, 1944, 2287, 2573],
  },
  {
    atLeast: 6751,
    notOver: 6800,
    credits: [240, 1958, 2304, 2592],
  },
  {
    atLeast: 6801,
    notOver: 6850,
    credits: [240, 1973, 2321, 2611],
  },
  {
    atLeast: 6851,
    notOver: 6900,
    credits: [239, 1987, 2338, 2630],
  },
  {
    atLeast: 6901,
    notOver: 6950,
    credits: [239, 2001, 2355, 2649],
  },
  {
    atLeast: 6951,
    notOver: 7000,
    credits: [239, 2016, 2372, 2668],
  },
  {
    atLeast: 7001,
    notOver: 7050,
    credits: [238, 2014, 2389, 2687],
  },
  {
    atLeast: 7051,
    notOver: 7100,
    credits: [238, 2000, 2406, 2706],
  },
  {
    atLeast: 7101,
    notOver: 7150,
    credits: [237, 1986, 2423, 2726],
  },
  {
    atLeast: 7151,
    notOver: 7200,
    credits: [237, 1971, 2440, 2745],
  },
  {
    atLeast: 7201,
    notOver: 7250,
    credits: [236, 1957, 2457, 2764],
  },
  {
    atLeast: 7251,
    notOver: 7300,
    credits: [236, 1942, 2474, 2783],
  },
  {
    atLeast: 7301,
    notOver: 7350,
    credits: [235, 1928, 2491, 2802],
  },
  {
    atLeast: 7351,
    notOver: 7400,
    credits: [235, 1913, 2508, 2821],
  },
  {
    atLeast: 7401,
    notOver: 7450,
    credits: [234, 1899, 2525, 2840],
  },
  {
    atLeast: 7451,
    notOver: 7500,
    credits: [234, 1884, 2542, 2859],
  },
  {
    atLeast: 7501,
    notOver: 7550,
    credits: [233, 1870, 2559, 2879],
  },
  {
    atLeast: 7551,
    notOver: 7600,
    credits: [233, 1856, 2576, 2898],
  },
  {
    atLeast: 7601,
    notOver: 7650,
    credits: [233, 1841, 2593, 2917],
  },
  {
    atLeast: 7651,
    notOver: 7700,
    credits: [232, 1827, 2610, 2936],
  },
  {
    atLeast: 7701,
    notOver: 7750,
    credits: [232, 1812, 2627, 2955],
  },
  {
    atLeast: 7751,
    notOver: 7800,
    credits: [231, 1798, 2644, 2974],
  },
  {
    atLeast: 7801,
    notOver: 7850,
    credits: [231, 1783, 2661, 2993],
  },
  {
    atLeast: 7851,
    notOver: 7900,
    credits: [230, 1769, 2678, 3012],
  },
  {
    atLeast: 7901,
    notOver: 7950,
    credits: [230, 1754, 2695, 3032],
  },
  {
    atLeast: 7951,
    notOver: 8000,
    credits: [229, 1740, 2712, 3051],
  },
  {
    atLeast: 8001,
    notOver: 8050,
    credits: [229, 1725, 2729, 3070],
  },
  {
    atLeast: 8051,
    notOver: 8100,
    credits: [228, 1711, 2746, 3089],
  },
  {
    atLeast: 8101,
    notOver: 8150,
    credits: [228, 1697, 2763, 3108],
  },
  {
    atLeast: 8151,
    notOver: 8200,
    credits: [228, 1682, 2780, 3127],
  },
  {
    atLeast: 8201,
    notOver: 8250,
    credits: [227, 1668, 2797, 3146],
  },
  {
    atLeast: 8251,
    notOver: 8300,
    credits: [227, 1653, 2814, 3165],
  },
  {
    atLeast: 8301,
    notOver: 8350,
    credits: [226, 1639, 2831, 3185],
  },
  {
    atLeast: 8351,
    notOver: 8400,
    credits: [226, 1624, 2848, 3204],
  },
  {
    atLeast: 8401,
    notOver: 8450,
    credits: [225, 1610, 2865, 3223],
  },
  {
    atLeast: 8451,
    notOver: 8500,
    credits: [225, 1595, 2882, 3242],
  },
  {
    atLeast: 8501,
    notOver: 8550,
    credits: [224, 1581, 2899, 3261],
  },
  {
    atLeast: 8551,
    notOver: 8600,
    credits: [224, 1567, 2916, 3280],
  },
  {
    atLeast: 8601,
    notOver: 8650,
    credits: [223, 1552, 2933, 3299],
  },
  {
    atLeast: 8651,
    notOver: 8700,
    credits: [223, 1538, 2950, 3318],
  },
  {
    atLeast: 8701,
    notOver: 8750,
    credits: [222, 1523, 2967, 3338],
  },
  {
    atLeast: 8751,
    notOver: 8800,
    credits: [222, 1509, 2984, 3357],
  },
  {
    atLeast: 8801,
    notOver: 8850,
    credits: [222, 1494, 3001, 3376],
  },
  {
    atLeast: 8851,
    notOver: 8900,
    credits: [221, 1480, 3018, 3395],
  },
  {
    atLeast: 8901,
    notOver: 8950,
    credits: [221, 1465, 3035, 3414],
  },
  {
    atLeast: 8951,
    notOver: 9000,
    credits: [220, 1451, 3052, 3433],
  },
  {
    atLeast: 9001,
    notOver: 9050,
    credits: [220, 1436, 3069, 3452],
  },
  {
    atLeast: 9051,
    notOver: 9100,
    credits: [219, 1422, 3086, 3471],
  },
  {
    atLeast: 9101,
    notOver: 9150,
    credits: [219, 1408, 3103, 3491],
  },
  {
    atLeast: 9151,
    notOver: 9200,
    credits: [218, 1393, 3120, 3510],
  },
  {
    atLeast: 9201,
    notOver: 9250,
    credits: [218, 1379, 3137, 3529],
  },
  {
    atLeast: 9251,
    notOver: 9300,
    credits: [217, 1364, 3154, 3548],
  },
  {
    atLeast: 9301,
    notOver: 9350,
    credits: [217, 1350, 3171, 3567],
  },
  {
    atLeast: 9351,
    notOver: 9400,
    credits: [216, 1335, 3188, 3586],
  },
  {
    atLeast: 9401,
    notOver: 9450,
    credits: [216, 1321, 3205, 3605],
  },
  {
    atLeast: 9451,
    notOver: 9500,
    credits: [216, 1306, 3222, 3624],
  },
  {
    atLeast: 9501,
    notOver: 9550,
    credits: [215, 1292, 3239, 3644],
  },
  {
    atLeast: 9551,
    notOver: 9600,
    credits: [215, 1278, 3256, 3663],
  },
  {
    atLeast: 9601,
    notOver: 9650,
    credits: [214, 1263, 3273, 3682],
  },
  {
    atLeast: 9651,
    notOver: 9700,
    credits: [214, 1249, 3290, 3701],
  },
  {
    atLeast: 9701,
    notOver: 9750,
    credits: [213, 1234, 3307, 3720],
  },
  {
    atLeast: 9751,
    notOver: 9800,
    credits: [213, 1220, 3324, 3739],
  },
  {
    atLeast: 9801,
    notOver: 9850,
    credits: [212, 1205, 3339, 3756],
  },
  {
    atLeast: 9851,
    notOver: 9900,
    credits: [212, 1191, 3322, 3737],
  },
  {
    atLeast: 9901,
    notOver: 9950,
    credits: [211, 1176, 3305, 3718],
  },
  {
    atLeast: 9951,
    notOver: 10000,
    credits: [211, 1162, 3288, 3699],
  },
  {
    atLeast: 10001,
    notOver: 10050,
    credits: [211, 1147, 3271, 3680],
  },
  {
    atLeast: 10051,
    notOver: 10100,
    credits: [210, 1133, 3254, 3661],
  },
  {
    atLeast: 10101,
    notOver: 10150,
    credits: [210, 1119, 3237, 3642],
  },
  {
    atLeast: 10151,
    notOver: 10200,
    credits: [209, 1104, 3220, 3622],
  },
  {
    atLeast: 10201,
    notOver: 10250,
    credits: [209, 1090, 3203, 3603],
  },
  {
    atLeast: 10251,
    notOver: 10300,
    credits: [208, 1075, 3186, 3584],
  },
  {
    atLeast: 10301,
    notOver: 10350,
    credits: [208, 1061, 3169, 3565],
  },
  {
    atLeast: 10351,
    notOver: 10400,
    credits: [207, 1046, 3152, 3546],
  },
  {
    atLeast: 10401,
    notOver: 10450,
    credits: [207, 1032, 3135, 3527],
  },
  {
    atLeast: 10451,
    notOver: 10500,
    credits: [206, 1017, 3118, 3508],
  },
  {
    atLeast: 10501,
    notOver: 10550,
    credits: [206, 1003, 3101, 3489],
  },
  {
    atLeast: 10551,
    notOver: 10600,
    credits: [205, 989, 3084, 3469],
  },
  {
    atLeast: 10601,
    notOver: 10650,
    credits: [205, 974, 3067, 3450],
  },
  {
    atLeast: 10651,
    notOver: 10700,
    credits: [205, 960, 3050, 3431],
  },
  {
    atLeast: 10701,
    notOver: 10750,
    credits: [204, 945, 3033, 3412],
  },
  {
    atLeast: 10751,
    notOver: 10800,
    credits: [204, 931, 3016, 3393],
  },
  {
    atLeast: 10801,
    notOver: 10850,
    credits: [203, 916, 2999, 3374],
  },
  {
    atLeast: 10851,
    notOver: 10900,
    credits: [203, 902, 2982, 3355],
  },
  {
    atLeast: 10901,
    notOver: 10950,
    credits: [202, 887, 2965, 3336],
  },
  {
    atLeast: 10951,
    notOver: 11000,
    credits: [202, 873, 2948, 3316],
  },
  {
    atLeast: 11001,
    notOver: 11050,
    credits: [201, 858, 2931, 3297],
  },
  {
    atLeast: 11051,
    notOver: 11100,
    credits: [201, 844, 2914, 3278],
  },
  {
    atLeast: 11101,
    notOver: 11150,
    credits: [200, 830, 2897, 3259],
  },
  {
    atLeast: 11151,
    notOver: 11200,
    credits: [200, 815, 2880, 3240],
  },
  {
    atLeast: 11201,
    notOver: 11250,
    credits: [200, 801, 2863, 3221],
  },
  {
    atLeast: 11251,
    notOver: 11300,
    credits: [199, 786, 2846, 3202],
  },
  {
    atLeast: 11301,
    notOver: 11350,
    credits: [199, 772, 2829, 3183],
  },
  {
    atLeast: 11351,
    notOver: 11400,
    credits: [198, 757, 2812, 3163],
  },
  {
    atLeast: 11401,
    notOver: 11450,
    credits: [198, 743, 2795, 3144],
  },
  {
    atLeast: 11451,
    notOver: 11500,
    credits: [197, 728, 2778, 3125],
  },
  {
    atLeast: 11501,
    notOver: 11550,
    credits: [197, 714, 2761, 3106],
  },
  {
    atLeast: 11551,
    notOver: 11600,
    credits: [196, 700, 2744, 3087],
  },
  {
    atLeast: 11601,
    notOver: 11650,
    credits: [196, 685, 2727, 3068],
  },
  {
    atLeast: 11651,
    notOver: 11700,
    credits: [195, 671, 2710, 3049],
  },
  {
    atLeast: 11701,
    notOver: 11750,
    credits: [195, 656, 2693, 3030],
  },
  {
    atLeast: 11751,
    notOver: 11800,
    credits: [194, 642, 2676, 3010],
  },
  {
    atLeast: 11801,
    notOver: 11850,
    credits: [194, 634, 2659, 2991],
  },
  {
    atLeast: 11851,
    notOver: 11900,
    credits: [194, 632, 2642, 2972],
  },
  {
    atLeast: 11901,
    notOver: 11950,
    credits: [193, 631, 2625, 2953],
  },
  {
    atLeast: 11951,
    notOver: 12000,
    credits: [193, 629, 2608, 2934],
  },
  {
    atLeast: 12001,
    notOver: 12050,
    credits: [192, 628, 2591, 2915],
  },
  {
    atLeast: 12051,
    notOver: 12100,
    credits: [192, 626, 2574, 2896],
  },
  {
    atLeast: 12101,
    notOver: 12150,
    credits: [191, 625, 2557, 2877],
  },
  {
    atLeast: 12151,
    notOver: 12200,
    credits: [191, 623, 2540, 2857],
  },
  {
    atLeast: 12201,
    notOver: 12250,
    credits: [190, 622, 2523, 2838],
  },
  {
    atLeast: 12251,
    notOver: 12300,
    credits: [190, 620, 2506, 2819],
  },
  {
    atLeast: 12301,
    notOver: 12350,
    credits: [189, 619, 2489, 2800],
  },
  {
    atLeast: 12351,
    notOver: 12400,
    credits: [189, 617, 2472, 2781],
  },
  {
    atLeast: 12401,
    notOver: 12450,
    credits: [188, 616, 2455, 2762],
  },
  {
    atLeast: 12451,
    notOver: 12500,
    credits: [188, 614, 2438, 2743],
  },
  {
    atLeast: 12501,
    notOver: 12550,
    credits: [188, 613, 2421, 2724],
  },
  {
    atLeast: 12551,
    notOver: 12600,
    credits: [187, 611, 2404, 2704],
  },
  {
    atLeast: 12601,
    notOver: 12650,
    credits: [187, 610, 2387, 2685],
  },
  {
    atLeast: 12651,
    notOver: 12700,
    credits: [186, 608, 2370, 2666],
  },
  {
    atLeast: 12701,
    notOver: 12750,
    credits: [186, 607, 2353, 2647],
  },
  {
    atLeast: 12751,
    notOver: 12800,
    credits: [185, 605, 2336, 2628],
  },
  {
    atLeast: 12801,
    notOver: 12850,
    credits: [185, 604, 2319, 2609],
  },
  {
    atLeast: 12851,
    notOver: 12900,
    credits: [184, 602, 2302, 2590],
  },
  {
    atLeast: 12901,
    notOver: 12950,
    credits: [184, 601, 2285, 2571],
  },
  {
    atLeast: 12951,
    notOver: 13000,
    credits: [183, 599, 2268, 2551],
  },
  {
    atLeast: 13001,
    notOver: 13050,
    credits: [183, 598, 2251, 2532],
  },
  {
    atLeast: 13051,
    notOver: 13100,
    credits: [183, 596, 2234, 2513],
  },
  {
    atLeast: 13101,
    notOver: 13150,
    credits: [182, 595, 2217, 2494],
  },
  {
    atLeast: 13151,
    notOver: 13200,
    credits: [182, 593, 2200, 2475],
  },
  {
    atLeast: 13201,
    notOver: 13250,
    credits: [181, 592, 2183, 2456],
  },
  {
    atLeast: 13251,
    notOver: 13300,
    credits: [181, 590, 2166, 2437],
  },
  {
    atLeast: 13301,
    notOver: 13350,
    credits: [180, 589, 2149, 2418],
  },
  {
    atLeast: 13351,
    notOver: 13400,
    credits: [180, 587, 2132, 2398],
  },
  {
    atLeast: 13401,
    notOver: 13450,
    credits: [179, 586, 2115, 2379],
  },
  {
    atLeast: 13451,
    notOver: 13500,
    credits: [179, 584, 2098, 2360],
  },
  {
    atLeast: 13501,
    notOver: 13550,
    credits: [178, 583, 2081, 2341],
  },
  {
    atLeast: 13551,
    notOver: 13600,
    credits: [178, 581, 2064, 2322],
  },
  {
    atLeast: 13601,
    notOver: 13650,
    credits: [177, 580, 2047, 2303],
  },
  {
    atLeast: 13651,
    notOver: 13700,
    credits: [177, 578, 2030, 2284],
  },
  {
    atLeast: 13701,
    notOver: 13750,
    credits: [177, 577, 2013, 2265],
  },
  {
    atLeast: 13751,
    notOver: 13800,
    credits: [176, 575, 1996, 2245],
  },
  {
    atLeast: 13801,
    notOver: 13850,
    credits: [176, 574, 1979, 2226],
  },
  {
    atLeast: 13851,
    notOver: 13900,
    credits: [175, 572, 1962, 2207],
  },
  {
    atLeast: 13901,
    notOver: 13950,
    credits: [175, 571, 1945, 2188],
  },
  {
    atLeast: 13951,
    notOver: 14000,
    credits: [174, 569, 1928, 2169],
  },
  {
    atLeast: 14001,
    notOver: 14050,
    credits: [174, 568, 1911, 2150],
  },
  {
    atLeast: 14051,
    notOver: 14100,
    credits: [173, 566, 1894, 2131],
  },
  {
    atLeast: 14101,
    notOver: 14150,
    credits: [173, 565, 1877, 2112],
  },
  {
    atLeast: 14151,
    notOver: 14200,
    credits: [172, 563, 1860, 2092],
  },
  {
    atLeast: 14201,
    notOver: 14250,
    credits: [172, 562, 1843, 2073],
  },
  {
    atLeast: 14251,
    notOver: 14300,
    credits: [172, 560, 1826, 2054],
  },
  {
    atLeast: 14301,
    notOver: 14350,
    credits: [171, 559, 1809, 2035],
  },
  {
    atLeast: 14351,
    notOver: 14400,
    credits: [171, 557, 1792, 2016],
  },
  {
    atLeast: 14401,
    notOver: 14450,
    credits: [170, 556, 1775, 1997],
  },
  {
    atLeast: 14451,
    notOver: 14500,
    credits: [170, 554, 1758, 1978],
  },
  {
    atLeast: 14501,
    notOver: 14550,
    credits: [169, 553, 1741, 1959],
  },
  {
    atLeast: 14551,
    notOver: 14600,
    credits: [169, 551, 1724, 1939],
  },
  {
    atLeast: 14601,
    notOver: 14650,
    credits: [168, 550, 1707, 1920],
  },
  {
    atLeast: 14651,
    notOver: 14700,
    credits: [168, 548, 1690, 1901],
  },
  {
    atLeast: 14701,
    notOver: 14750,
    credits: [167, 547, 1673, 1882],
  },
  {
    atLeast: 14751,
    notOver: 14800,
    credits: [167, 545, 1656, 1863],
  },
  {
    atLeast: 14801,
    notOver: 14850,
    credits: [166, 544, 1639, 1844],
  },
  {
    atLeast: 14851,
    notOver: 14900,
    credits: [166, 542, 1622, 1825],
  },
  {
    atLeast: 14901,
    notOver: 14950,
    credits: [166, 541, 1605, 1806],
  },
  {
    atLeast: 14951,
    notOver: 15000,
    credits: [165, 539, 1588, 1786],
  },
  {
    atLeast: 15001,
    notOver: 15050,
    credits: [165, 538, 1571, 1767],
  },
  {
    atLeast: 15051,
    notOver: 15100,
    credits: [164, 536, 1554, 1748],
  },
  {
    atLeast: 15101,
    notOver: 15150,
    credits: [164, 535, 1537, 1729],
  },
  {
    atLeast: 15151,
    notOver: 15200,
    credits: [163, 533, 1520, 1710],
  },
  {
    atLeast: 15201,
    notOver: 15250,
    credits: [163, 532, 1503, 1691],
  },
  {
    atLeast: 15251,
    notOver: 15300,
    credits: [162, 530, 1486, 1672],
  },
  {
    atLeast: 15301,
    notOver: 15350,
    credits: [162, 529, 1469, 1653],
  },
  {
    atLeast: 15351,
    notOver: 15400,
    credits: [161, 527, 1452, 1633],
  },
  {
    atLeast: 15401,
    notOver: 15450,
    credits: [161, 526, 1435, 1614],
  },
  {
    atLeast: 15451,
    notOver: 15500,
    credits: [160, 524, 1418, 1595],
  },
  {
    atLeast: 15501,
    notOver: 15550,
    credits: [160, 523, 1401, 1576],
  },
  {
    atLeast: 15551,
    notOver: 15600,
    credits: [160, 521, 1384, 1557],
  },
  {
    atLeast: 15601,
    notOver: 15650,
    credits: [159, 520, 1367, 1538],
  },
  {
    atLeast: 15651,
    notOver: 15700,
    credits: [159, 518, 1350, 1519],
  },
  {
    atLeast: 15701,
    notOver: 15750,
    credits: [158, 517, 1333, 1500],
  },
  {
    atLeast: 15751,
    notOver: 15800,
    credits: [158, 515, 1316, 1480],
  },
  {
    atLeast: 15801,
    notOver: 15850,
    credits: [157, 514, 1299, 1461],
  },
  {
    atLeast: 15851,
    notOver: 15900,
    credits: [157, 512, 1282, 1442],
  },
  {
    atLeast: 15901,
    notOver: 15950,
    credits: [156, 511, 1265, 1423],
  },
  {
    atLeast: 15951,
    notOver: 16000,
    credits: [156, 509, 1248, 1404],
  },
  {
    atLeast: 16001,
    notOver: 16050,
    credits: [155, 508, 1231, 1385],
  },
  {
    atLeast: 16051,
    notOver: 16100,
    credits: [155, 506, 1214, 1366],
  },
  {
    atLeast: 16101,
    notOver: 16150,
    credits: [155, 505, 1197, 1347],
  },
  {
    atLeast: 16151,
    notOver: 16200,
    credits: [154, 503, 1180, 1327],
  },
  {
    atLeast: 16201,
    notOver: 16250,
    credits: [154, 502, 1163, 1308],
  },
  {
    atLeast: 16251,
    notOver: 16300,
    credits: [153, 500, 1146, 1289],
  },
  {
    atLeast: 16301,
    notOver: 16350,
    credits: [153, 499, 1129, 1270],
  },
  {
    atLeast: 16351,
    notOver: 16400,
    credits: [152, 497, 1112, 1251],
  },
  {
    atLeast: 16401,
    notOver: 16450,
    credits: [152, 496, 1095, 1232],
  },
  {
    atLeast: 16451,
    notOver: 16500,
    credits: [151, 494, 1078, 1213],
  },
  {
    atLeast: 16501,
    notOver: 16550,
    credits: [151, 493, 1061, 1194],
  },
  {
    atLeast: 16551,
    notOver: 16600,
    credits: [150, 491, 1044, 1174],
  },
  {
    atLeast: 16601,
    notOver: 16650,
    credits: [150, 490, 1027, 1155],
  },
  {
    atLeast: 16651,
    notOver: 16700,
    credits: [149, 488, 1010, 1136],
  },
  {
    atLeast: 16701,
    notOver: 16750,
    credits: [149, 487, 993, 1117],
  },
  {
    atLeast: 16751,
    notOver: 16800,
    credits: [149, 485, 976, 1098],
  },
  {
    atLeast: 16801,
    notOver: 16850,
    credits: [148, 484, 959, 1079],
  },
  {
    atLeast: 16851,
    notOver: 16900,
    credits: [148, 482, 942, 1060],
  },
  {
    atLeast: 16901,
    notOver: 16950,
    credits: [147, 481, 925, 1041],
  },
  {
    atLeast: 16951,
    notOver: 17000,
    credits: [147, 479, 908, 1021],
  },
  {
    atLeast: 17001,
    notOver: 17050,
    credits: [146, 477, 891, 1002],
  },
  {
    atLeast: 17051,
    notOver: 17100,
    credits: [146, 476, 874, 983],
  },
  {
    atLeast: 17101,
    notOver: 17150,
    credits: [145, 474, 857, 964],
  },
  {
    atLeast: 17151,
    notOver: 17200,
    credits: [145, 473, 840, 945],
  },
  {
    atLeast: 17201,
    notOver: 17250,
    credits: [144, 471, 823, 926],
  },
  {
    atLeast: 17251,
    notOver: 17300,
    credits: [144, 470, 806, 907],
  },
  {
    atLeast: 17301,
    notOver: 17350,
    credits: [144, 468, 789, 888],
  },
  {
    atLeast: 17351,
    notOver: 17400,
    credits: [143, 467, 772, 868],
  },
  {
    atLeast: 17401,
    notOver: 17450,
    credits: [143, 465, 755, 849],
  },
  {
    atLeast: 17451,
    notOver: 17500,
    credits: [142, 464, 738, 830],
  },
  {
    atLeast: 17501,
    notOver: 17550,
    credits: [142, 462, 721, 811],
  },
  {
    atLeast: 17551,
    notOver: 17600,
    credits: [141, 461, 704, 792],
  },
  {
    atLeast: 17601,
    notOver: 17650,
    credits: [141, 459, 687, 773],
  },
  {
    atLeast: 17651,
    notOver: 17700,
    credits: [140, 458, 670, 754],
  },
  {
    atLeast: 17701,
    notOver: 17750,
    credits: [140, 456, 653, 735],
  },
  {
    atLeast: 17751,
    notOver: 17800,
    credits: [139, 455, 636, 715],
  },
  {
    atLeast: 17801,
    notOver: 17850,
    credits: [139, 453, 633, 696],
  },
  {
    atLeast: 17851,
    notOver: 17900,
    credits: [138, 452, 631, 677],
  },
  {
    atLeast: 17901,
    notOver: 17950,
    credits: [138, 450, 629, 658],
  },
  {
    atLeast: 17951,
    notOver: 18000,
    credits: [138, 449, 626, 639],
  },
  {
    atLeast: 18001,
    notOver: 18050,
    credits: [137, 447, 624, 633],
  },
  {
    atLeast: 18051,
    notOver: 18100,
    credits: [137, 446, 622, 631],
  },
  {
    atLeast: 18101,
    notOver: 18150,
    credits: [136, 444, 620, 629],
  },
  {
    atLeast: 18151,
    notOver: 18200,
    credits: [136, 443, 618, 626],
  },
  {
    atLeast: 18201,
    notOver: 18250,
    credits: [135, 441, 616, 624],
  },
  {
    atLeast: 18251,
    notOver: 18300,
    credits: [135, 440, 614, 622],
  },
  {
    atLeast: 18301,
    notOver: 18350,
    credits: [134, 438, 612, 620],
  },
  {
    atLeast: 18351,
    notOver: 18400,
    credits: [134, 437, 610, 618],
  },
  {
    atLeast: 18401,
    notOver: 18450,
    credits: [133, 435, 608, 616],
  },
  {
    atLeast: 18451,
    notOver: 18500,
    credits: [133, 434, 605, 614],
  },
  {
    atLeast: 18501,
    notOver: 18550,
    credits: [132, 432, 603, 612],
  },
  {
    atLeast: 18551,
    notOver: 18600,
    credits: [132, 431, 601, 609],
  },
  {
    atLeast: 18601,
    notOver: 18650,
    credits: [132, 429, 599, 607],
  },
  {
    atLeast: 18651,
    notOver: 18700,
    credits: [131, 428, 597, 605],
  },
  {
    atLeast: 18701,
    notOver: 18750,
    credits: [131, 426, 595, 603],
  },
  {
    atLeast: 18751,
    notOver: 18800,
    credits: [130, 425, 593, 601],
  },
  {
    atLeast: 18801,
    notOver: 18850,
    credits: [130, 423, 591, 599],
  },
  {
    atLeast: 18851,
    notOver: 18900,
    credits: [129, 422, 589, 597],
  },
  {
    atLeast: 18901,
    notOver: 18950,
    credits: [129, 420, 587, 595],
  },
  {
    atLeast: 18951,
    notOver: 19000,
    credits: [128, 419, 584, 592],
  },
  {
    atLeast: 19001,
    notOver: 19050,
    credits: [128, 417, 582, 590],
  },
  {
    atLeast: 19051,
    notOver: 19100,
    credits: [127, 416, 580, 588],
  },
  {
    atLeast: 19101,
    notOver: 19150,
    credits: [127, 414, 578, 586],
  },
  {
    atLeast: 19151,
    notOver: 19200,
    credits: [127, 413, 576, 584],
  },
  {
    atLeast: 19201,
    notOver: 19250,
    credits: [126, 411, 574, 582],
  },
  {
    atLeast: 19251,
    notOver: 19300,
    credits: [126, 410, 572, 580],
  },
  {
    atLeast: 19301,
    notOver: 19350,
    credits: [125, 408, 570, 577],
  },
  {
    atLeast: 19351,
    notOver: 19400,
    credits: [125, 407, 568, 575],
  },
  {
    atLeast: 19401,
    notOver: 19450,
    credits: [124, 405, 566, 573],
  },
  {
    atLeast: 19451,
    notOver: 19500,
    credits: [124, 404, 563, 571],
  },
  {
    atLeast: 19501,
    notOver: 19550,
    credits: [123, 402, 561, 569],
  },
  {
    atLeast: 19551,
    notOver: 19600,
    credits: [123, 401, 559, 567],
  },
  {
    atLeast: 19601,
    notOver: 19650,
    credits: [122, 399, 557, 565],
  },
  {
    atLeast: 19651,
    notOver: 19700,
    credits: [122, 398, 555, 563],
  },
  {
    atLeast: 19701,
    notOver: 19750,
    credits: [121, 396, 553, 560],
  },
  {
    atLeast: 19751,
    notOver: 19800,
    credits: [121, 395, 551, 558],
  },
  {
    atLeast: 19801,
    notOver: 19850,
    credits: [121, 393, 549, 556],
  },
  {
    atLeast: 19851,
    notOver: 19900,
    credits: [120, 392, 547, 554],
  },
  {
    atLeast: 19901,
    notOver: 19950,
    credits: [120, 390, 545, 552],
  },
  {
    atLeast: 19951,
    notOver: 20000,
    credits: [119, 389, 542, 550],
  },
  {
    atLeast: 20001,
    notOver: 20050,
    credits: [119, 387, 540, 548],
  },
  {
    atLeast: 20051,
    notOver: 20100,
    credits: [118, 386, 538, 546],
  },
  {
    atLeast: 20101,
    notOver: 20150,
    credits: [118, 384, 536, 543],
  },
  {
    atLeast: 20151,
    notOver: 20200,
    credits: [117, 383, 534, 541],
  },
  {
    atLeast: 20201,
    notOver: 20250,
    credits: [117, 381, 532, 539],
  },
  {
    atLeast: 20251,
    notOver: 20300,
    credits: [116, 380, 530, 537],
  },
  {
    atLeast: 20301,
    notOver: 20350,
    credits: [116, 378, 528, 535],
  },
  {
    atLeast: 20351,
    notOver: 20400,
    credits: [116, 377, 526, 533],
  },
  {
    atLeast: 20401,
    notOver: 20450,
    credits: [115, 375, 524, 531],
  },
  {
    atLeast: 20451,
    notOver: 20500,
    credits: [115, 374, 521, 529],
  },
  {
    atLeast: 20501,
    notOver: 20550,
    credits: [114, 372, 519, 526],
  },
  {
    atLeast: 20551,
    notOver: 20600,
    credits: [114, 371, 517, 524],
  },
  {
    atLeast: 20601,
    notOver: 20650,
    credits: [113, 369, 515, 522],
  },
  {
    atLeast: 20651,
    notOver: 20700,
    credits: [113, 368, 513, 520],
  },
  {
    atLeast: 20701,
    notOver: 20750,
    credits: [112, 366, 511, 518],
  },
  {
    atLeast: 20751,
    notOver: 20800,
    credits: [112, 365, 509, 516],
  },
  {
    atLeast: 20801,
    notOver: 20850,
    credits: [111, 363, 507, 514],
  },
  {
    atLeast: 20851,
    notOver: 20900,
    credits: [111, 362, 505, 511],
  },
  {
    atLeast: 20901,
    notOver: 20950,
    credits: [110, 360, 503, 509],
  },
  {
    atLeast: 20951,
    notOver: 21000,
    credits: [110, 359, 500, 507],
  },
  {
    atLeast: 21001,
    notOver: 21050,
    credits: [110, 357, 498, 505],
  },
  {
    atLeast: 21051,
    notOver: 21100,
    credits: [109, 356, 496, 503],
  },
  {
    atLeast: 21101,
    notOver: 21150,
    credits: [109, 354, 494, 501],
  },
  {
    atLeast: 21151,
    notOver: 21200,
    credits: [108, 353, 492, 499],
  },
  {
    atLeast: 21201,
    notOver: 21250,
    credits: [108, 351, 490, 497],
  },
  {
    atLeast: 21251,
    notOver: 21300,
    credits: [107, 350, 488, 494],
  },
  {
    atLeast: 21301,
    notOver: 21350,
    credits: [107, 348, 486, 492],
  },
  {
    atLeast: 21351,
    notOver: 21400,
    credits: [106, 347, 484, 490],
  },
  {
    atLeast: 21401,
    notOver: 21450,
    credits: [106, 345, 482, 488],
  },
  {
    atLeast: 21451,
    notOver: 21500,
    credits: [105, 344, 479, 486],
  },
  {
    atLeast: 21501,
    notOver: 21550,
    credits: [105, 342, 477, 484],
  },
  {
    atLeast: 21551,
    notOver: 21600,
    credits: [104, 341, 475, 482],
  },
  {
    atLeast: 21601,
    notOver: 21650,
    credits: [104, 339, 473, 480],
  },
  {
    atLeast: 21651,
    notOver: 21700,
    credits: [104, 338, 471, 477],
  },
  {
    atLeast: 21701,
    notOver: 21750,
    credits: [103, 336, 469, 475],
  },
  {
    atLeast: 21751,
    notOver: 21800,
    credits: [103, 335, 467, 473],
  },
  {
    atLeast: 21801,
    notOver: 21850,
    credits: [102, 333, 465, 471],
  },
  {
    atLeast: 21851,
    notOver: 21900,
    credits: [102, 332, 463, 469],
  },
  {
    atLeast: 21901,
    notOver: 21950,
    credits: [101, 330, 461, 467],
  },
  {
    atLeast: 21951,
    notOver: 22000,
    credits: [101, 329, 458, 465],
  },
  {
    atLeast: 22001,
    notOver: 22050,
    credits: [100, 327, 456, 463],
  },
  {
    atLeast: 22051,
    notOver: 22100,
    credits: [100, 326, 454, 460],
  },
  {
    atLeast: 22101,
    notOver: 22150,
    credits: [99, 324, 452, 458],
  },
  {
    atLeast: 22151,
    notOver: 22200,
    credits: [99, 323, 450, 456],
  },
  {
    atLeast: 22201,
    notOver: 22250,
    credits: [99, 321, 448, 454],
  },
  {
    atLeast: 22251,
    notOver: 22300,
    credits: [98, 320, 446, 452],
  },
  {
    atLeast: 22301,
    notOver: 22350,
    credits: [98, 318, 444, 450],
  },
  {
    atLeast: 22351,
    notOver: 22400,
    credits: [97, 317, 442, 448],
  },
  {
    atLeast: 22401,
    notOver: 22450,
    credits: [97, 315, 440, 445],
  },
  {
    atLeast: 22451,
    notOver: 22500,
    credits: [96, 314, 438, 443],
  },
  {
    atLeast: 22501,
    notOver: 22550,
    credits: [96, 312, 435, 441],
  },
  {
    atLeast: 22551,
    notOver: 22600,
    credits: [95, 310, 433, 439],
  },
  {
    atLeast: 22601,
    notOver: 22650,
    credits: [95, 309, 431, 437],
  },
  {
    atLeast: 22651,
    notOver: 22700,
    credits: [94, 307, 429, 435],
  },
  {
    atLeast: 22701,
    notOver: 22750,
    credits: [94, 306, 427, 433],
  },
  {
    atLeast: 22751,
    notOver: 22800,
    credits: [93, 304, 425, 431],
  },
  {
    atLeast: 22801,
    notOver: 22850,
    credits: [93, 303, 423, 428],
  },
  {
    atLeast: 22851,
    notOver: 22900,
    credits: [93, 301, 421, 426],
  },
  {
    atLeast: 22901,
    notOver: 22950,
    credits: [92, 300, 419, 424],
  },
  {
    atLeast: 22951,
    notOver: 23000,
    credits: [92, 298, 417, 422],
  },
  {
    atLeast: 23001,
    notOver: 23050,
    credits: [91, 297, 414, 420],
  },
  {
    atLeast: 23051,
    notOver: 23100,
    credits: [91, 295, 412, 418],
  },
  {
    atLeast: 23101,
    notOver: 23150,
    credits: [90, 294, 410, 416],
  },
  {
    atLeast: 23151,
    notOver: 23200,
    credits: [90, 292, 408, 414],
  },
  {
    atLeast: 23201,
    notOver: 23250,
    credits: [89, 291, 406, 411],
  },
  {
    atLeast: 23251,
    notOver: 23300,
    credits: [89, 289, 404, 409],
  },
  {
    atLeast: 23301,
    notOver: 23350,
    credits: [88, 288, 402, 407],
  },
  {
    atLeast: 23351,
    notOver: 23400,
    credits: [88, 286, 400, 405],
  },
  {
    atLeast: 23401,
    notOver: 23450,
    credits: [88, 285, 398, 403],
  },
  {
    atLeast: 23451,
    notOver: 23500,
    credits: [87, 283, 396, 401],
  },
  {
    atLeast: 23501,
    notOver: 23550,
    credits: [87, 282, 393, 399],
  },
  {
    atLeast: 23551,
    notOver: 23600,
    credits: [86, 280, 391, 397],
  },
  {
    atLeast: 23601,
    notOver: 23650,
    credits: [86, 279, 389, 394],
  },
  {
    atLeast: 23651,
    notOver: 23700,
    credits: [85, 277, 387, 392],
  },
  {
    atLeast: 23701,
    notOver: 23750,
    credits: [85, 276, 385, 390],
  },
  {
    atLeast: 23751,
    notOver: 23800,
    credits: [84, 274, 383, 388],
  },
  {
    atLeast: 23801,
    notOver: 23850,
    credits: [84, 273, 381, 386],
  },
  {
    atLeast: 23851,
    notOver: 23900,
    credits: [83, 271, 379, 384],
  },
  {
    atLeast: 23901,
    notOver: 23950,
    credits: [83, 270, 377, 382],
  },
  {
    atLeast: 23951,
    notOver: 24000,
    credits: [82, 268, 375, 379],
  },
  {
    atLeast: 24001,
    notOver: 24050,
    credits: [82, 267, 372, 377],
  },
  {
    atLeast: 24051,
    notOver: 24100,
    credits: [82, 265, 370, 375],
  },
  {
    atLeast: 24101,
    notOver: 24150,
    credits: [81, 264, 368, 373],
  },
  {
    atLeast: 24151,
    notOver: 24200,
    credits: [81, 262, 366, 371],
  },
  {
    atLeast: 24201,
    notOver: 24250,
    credits: [80, 261, 364, 369],
  },
  {
    atLeast: 24251,
    notOver: 24300,
    credits: [80, 259, 362, 367],
  },
  {
    atLeast: 24301,
    notOver: 24350,
    credits: [79, 258, 360, 365],
  },
  {
    atLeast: 24351,
    notOver: 24400,
    credits: [79, 256, 358, 362],
  },
  {
    atLeast: 24401,
    notOver: 24450,
    credits: [78, 255, 356, 360],
  },
  {
    atLeast: 24451,
    notOver: 24500,
    credits: [78, 253, 354, 358],
  },
  {
    atLeast: 24501,
    notOver: 24550,
    credits: [77, 252, 351, 356],
  },
  {
    atLeast: 24551,
    notOver: 24600,
    credits: [77, 250, 349, 354],
  },
  {
    atLeast: 24601,
    notOver: 24650,
    credits: [76, 249, 347, 352],
  },
  {
    atLeast: 24651,
    notOver: 24700,
    credits: [76, 247, 345, 350],
  },
  {
    atLeast: 24701,
    notOver: 24750,
    credits: [76, 246, 343, 348],
  },
  {
    atLeast: 24751,
    notOver: 24800,
    credits: [75, 244, 341, 345],
  },
  {
    atLeast: 24801,
    notOver: 24850,
    credits: [75, 243, 339, 343],
  },
  {
    atLeast: 24851,
    notOver: 24900,
    credits: [74, 241, 337, 341],
  },
  {
    atLeast: 24901,
    notOver: 24950,
    credits: [74, 240, 335, 339],
  },
  {
    atLeast: 24951,
    notOver: 25000,
    credits: [73, 238, 333, 337],
  },
  {
    atLeast: 25001,
    notOver: 25050,
    credits: [73, 237, 330, 335],
  },
  {
    atLeast: 25051,
    notOver: 25100,
    credits: [72, 235, 328, 333],
  },
  {
    atLeast: 25101,
    notOver: 25150,
    credits: [72, 234, 326, 330],
  },
  {
    atLeast: 25151,
    notOver: 25200,
    credits: [71, 232, 324, 328],
  },
  {
    atLeast: 25201,
    notOver: 25250,
    credits: [71, 231, 322, 326],
  },
  {
    atLeast: 25251,
    notOver: 25300,
    credits: [71, 229, 320, 324],
  },
  {
    atLeast: 25301,
    notOver: 25350,
    credits: [70, 228, 318, 322],
  },
  {
    atLeast: 25351,
    notOver: 25400,
    credits: [70, 226, 316, 320],
  },
  {
    atLeast: 25401,
    notOver: 25450,
    credits: [69, 225, 314, 318],
  },
  {
    atLeast: 25451,
    notOver: 25500,
    credits: [69, 223, 312, 316],
  },
  {
    atLeast: 25501,
    notOver: 25550,
    credits: [68, 222, 309, 313],
  },
  {
    atLeast: 25551,
    notOver: 25600,
    credits: [68, 220, 307, 311],
  },
  {
    atLeast: 25601,
    notOver: 25650,
    credits: [67, 219, 305, 309],
  },
  {
    atLeast: 25651,
    notOver: 25700,
    credits: [67, 217, 303, 307],
  },
  {
    atLeast: 25701,
    notOver: 25750,
    credits: [66, 216, 301, 305],
  },
  {
    atLeast: 25751,
    notOver: 25800,
    credits: [66, 214, 299, 303],
  },
  {
    atLeast: 25801,
    notOver: 25850,
    credits: [65, 213, 297, 301],
  },
  {
    atLeast: 25851,
    notOver: 25900,
    credits: [65, 211, 295, 299],
  },
  {
    atLeast: 25901,
    notOver: 25950,
    credits: [65, 210, 293, 296],
  },
  {
    atLeast: 25951,
    notOver: 26000,
    credits: [64, 208, 291, 294],
  },
  {
    atLeast: 26001,
    notOver: 26050,
    credits: [64, 207, 288, 292],
  },
  {
    atLeast: 26051,
    notOver: 26100,
    credits: [63, 205, 286, 290],
  },
  {
    atLeast: 26101,
    notOver: 26150,
    credits: [63, 204, 284, 288],
  },
  {
    atLeast: 26151,
    notOver: 26200,
    credits: [62, 202, 282, 286],
  },
  {
    atLeast: 26201,
    notOver: 26250,
    credits: [62, 201, 280, 284],
  },
  {
    atLeast: 26251,
    notOver: 26300,
    credits: [61, 199, 278, 282],
  },
  {
    atLeast: 26301,
    notOver: 26350,
    credits: [61, 198, 276, 279],
  },
  {
    atLeast: 26351,
    notOver: 26400,
    credits: [60, 196, 274, 277],
  },
  {
    atLeast: 26401,
    notOver: 26450,
    credits: [60, 195, 272, 275],
  },
  {
    atLeast: 26451,
    notOver: 26500,
    credits: [60, 193, 270, 273],
  },
  {
    atLeast: 26501,
    notOver: 26550,
    credits: [59, 192, 267, 271],
  },
  {
    atLeast: 26551,
    notOver: 26600,
    credits: [59, 190, 265, 269],
  },
  {
    atLeast: 26601,
    notOver: 26650,
    credits: [58, 189, 263, 267],
  },
  {
    atLeast: 26651,
    notOver: 26700,
    credits: [58, 187, 261, 264],
  },
  {
    atLeast: 26701,
    notOver: 26750,
    credits: [57, 186, 259, 262],
  },
  {
    atLeast: 26751,
    notOver: 26800,
    credits: [57, 184, 257, 260],
  },
  {
    atLeast: 26801,
    notOver: 26850,
    credits: [56, 183, 255, 258],
  },
  {
    atLeast: 26851,
    notOver: 26900,
    credits: [56, 181, 253, 256],
  },
  {
    atLeast: 26901,
    notOver: 26950,
    credits: [55, 180, 251, 254],
  },
  {
    atLeast: 26951,
    notOver: 27000,
    credits: [55, 178, 249, 252],
  },
  {
    atLeast: 27001,
    notOver: 27050,
    credits: [54, 177, 246, 250],
  },
  {
    atLeast: 27051,
    notOver: 27100,
    credits: [54, 175, 244, 247],
  },
  {
    atLeast: 27101,
    notOver: 27150,
    credits: [54, 174, 242, 245],
  },
  {
    atLeast: 27151,
    notOver: 27200,
    credits: [53, 172, 240, 243],
  },
  {
    atLeast: 27201,
    notOver: 27250,
    credits: [53, 171, 238, 241],
  },
  {
    atLeast: 27251,
    notOver: 27300,
    credits: [52, 169, 236, 239],
  },
  {
    atLeast: 27301,
    notOver: 27350,
    credits: [52, 168, 234, 237],
  },
  {
    atLeast: 27351,
    notOver: 27400,
    credits: [51, 166, 232, 235],
  },
  {
    atLeast: 27401,
    notOver: 27450,
    credits: [51, 165, 230, 233],
  },
  {
    atLeast: 27451,
    notOver: 27500,
    credits: [50, 163, 228, 230],
  },
  {
    atLeast: 27501,
    notOver: 27550,
    credits: [50, 162, 225, 228],
  },
  {
    atLeast: 27551,
    notOver: 27600,
    credits: [49, 160, 223, 226],
  },
  {
    atLeast: 27601,
    notOver: 27650,
    credits: [49, 159, 221, 224],
  },
  {
    atLeast: 27651,
    notOver: 27700,
    credits: [48, 157, 219, 222],
  },
  {
    atLeast: 27701,
    notOver: 27750,
    credits: [48, 156, 217, 220],
  },
  {
    atLeast: 27751,
    notOver: 27800,
    credits: [48, 154, 215, 218],
  },
  {
    atLeast: 27801,
    notOver: 27850,
    credits: [47, 153, 213, 216],
  },
  {
    atLeast: 27851,
    notOver: 27900,
    credits: [47, 151, 211, 213],
  },
  {
    atLeast: 27901,
    notOver: 27950,
    credits: [46, 150, 209, 211],
  },
  {
    atLeast: 27951,
    notOver: 28000,
    credits: [46, 148, 207, 209],
  },
  {
    atLeast: 28001,
    notOver: 28050,
    credits: [45, 147, 204, 207],
  },
  {
    atLeast: 28051,
    notOver: 28100,
    credits: [45, 145, 202, 205],
  },
  {
    atLeast: 28101,
    notOver: 28150,
    credits: [44, 143, 200, 203],
  },
  {
    atLeast: 28151,
    notOver: 28200,
    credits: [44, 142, 198, 201],
  },
  {
    atLeast: 28201,
    notOver: 28250,
    credits: [43, 140, 196, 198],
  },
  {
    atLeast: 28251,
    notOver: 28300,
    credits: [43, 139, 194, 196],
  },
  {
    atLeast: 28301,
    notOver: 28350,
    credits: [43, 137, 192, 194],
  },
  {
    atLeast: 28351,
    notOver: 28400,
    credits: [42, 136, 190, 192],
  },
  {
    atLeast: 28401,
    notOver: 28450,
    credits: [42, 134, 188, 190],
  },
  {
    atLeast: 28451,
    notOver: 28500,
    credits: [41, 133, 186, 188],
  },
  {
    atLeast: 28501,
    notOver: 28550,
    credits: [41, 131, 183, 186],
  },
  {
    atLeast: 28551,
    notOver: 28600,
    credits: [40, 130, 181, 184],
  },
  {
    atLeast: 28601,
    notOver: 28650,
    credits: [40, 128, 179, 181],
  },
  {
    atLeast: 28651,
    notOver: 28700,
    credits: [39, 127, 177, 179],
  },
  {
    atLeast: 28701,
    notOver: 28750,
    credits: [39, 125, 175, 177],
  },
  {
    atLeast: 28751,
    notOver: 28800,
    credits: [38, 124, 173, 175],
  },
  {
    atLeast: 28801,
    notOver: 28850,
    credits: [38, 122, 171, 173],
  },
  {
    atLeast: 28851,
    notOver: 28900,
    credits: [37, 121, 169, 171],
  },
  {
    atLeast: 28901,
    notOver: 28950,
    credits: [37, 119, 167, 169],
  },
  {
    atLeast: 28951,
    notOver: 29000,
    credits: [37, 118, 165, 167],
  },
  {
    atLeast: 29001,
    notOver: 29050,
    credits: [36, 116, 162, 164],
  },
  {
    atLeast: 29051,
    notOver: 29100,
    credits: [36, 115, 160, 162],
  },
  {
    atLeast: 29101,
    notOver: 29150,
    credits: [35, 113, 158, 160],
  },
  {
    atLeast: 29151,
    notOver: 29200,
    credits: [35, 112, 156, 158],
  },
  {
    atLeast: 29201,
    notOver: 29250,
    credits: [34, 110, 154, 156],
  },
  {
    atLeast: 29251,
    notOver: 29300,
    credits: [34, 109, 152, 154],
  },
  {
    atLeast: 29301,
    notOver: 29350,
    credits: [33, 107, 150, 152],
  },
  {
    atLeast: 29351,
    notOver: 29400,
    credits: [33, 106, 148, 150],
  },
  {
    atLeast: 29401,
    notOver: 29450,
    credits: [32, 104, 146, 147],
  },
  {
    atLeast: 29451,
    notOver: 29500,
    credits: [32, 103, 144, 145],
  },
  {
    atLeast: 29501,
    notOver: 29550,
    credits: [32, 101, 141, 143],
  },
  {
    atLeast: 29551,
    notOver: 29600,
    credits: [31, 100, 139, 141],
  },
  {
    atLeast: 29601,
    notOver: 29650,
    credits: [31, 98, 137, 139],
  },
  {
    atLeast: 29651,
    notOver: 29700,
    credits: [30, 97, 135, 137],
  },
  {
    atLeast: 29701,
    notOver: 29750,
    credits: [30, 95, 133, 135],
  },
  {
    atLeast: 29751,
    notOver: 29800,
    credits: [29, 94, 131, 132],
  },
  {
    atLeast: 29801,
    notOver: 29850,
    credits: [29, 92, 129, 130],
  },
  {
    atLeast: 29851,
    notOver: 29900,
    credits: [28, 91, 127, 128],
  },
  {
    atLeast: 29901,
    notOver: 29950,
    credits: [28, 89, 125, 126],
  },
  {
    atLeast: 29951,
    notOver: 30000,
    credits: [27, 88, 123, 124],
  },
  {
    atLeast: 30001,
    notOver: 30050,
    credits: [27, 86, 120, 122],
  },
  {
    atLeast: 30051,
    notOver: 30100,
    credits: [26, 85, 118, 120],
  },
  {
    atLeast: 30101,
    notOver: 30150,
    credits: [26, 83, 116, 118],
  },
  {
    atLeast: 30151,
    notOver: 30200,
    credits: [26, 82, 114, 115],
  },
  {
    atLeast: 30201,
    notOver: 30250,
    credits: [25, 80, 112, 113],
  },
  {
    atLeast: 30251,
    notOver: 30300,
    credits: [25, 79, 110, 111],
  },
  {
    atLeast: 30301,
    notOver: 30350,
    credits: [24, 77, 108, 109],
  },
  {
    atLeast: 30351,
    notOver: 30400,
    credits: [24, 76, 106, 107],
  },
  {
    atLeast: 30401,
    notOver: 30450,
    credits: [23, 74, 104, 105],
  },
  {
    atLeast: 30451,
    notOver: 30500,
    credits: [23, 73, 102, 103],
  },
  {
    atLeast: 30501,
    notOver: 30550,
    credits: [22, 71, 99, 101],
  },
  {
    atLeast: 30551,
    notOver: 30600,
    credits: [22, 70, 97, 98],
  },
  {
    atLeast: 30601,
    notOver: 30650,
    credits: [21, 68, 95, 96],
  },
  {
    atLeast: 30651,
    notOver: 30700,
    credits: [21, 67, 93, 94],
  },
  {
    atLeast: 30701,
    notOver: 30750,
    credits: [20, 65, 91, 92],
  },
  {
    atLeast: 30751,
    notOver: 30800,
    credits: [20, 64, 89, 90],
  },
  {
    atLeast: 30801,
    notOver: 30850,
    credits: [20, 62, 87, 88],
  },
  {
    atLeast: 30851,
    notOver: 30900,
    credits: [19, 61, 85, 86],
  },
  {
    atLeast: 30901,
    notOver: 30950,
    credits: [19, 59, 83, 84],
  },
  {
    atLeast: 30951,
    notOver: 31000,
    credits: [18, 58, 81, 81],
  },
  {
    atLeast: 31001,
    notOver: 31050,
    credits: [18, 56, 78, 79],
  },
  {
    atLeast: 31051,
    notOver: 31100,
    credits: [17, 55, 76, 77],
  },
  {
    atLeast: 31101,
    notOver: 31150,
    credits: [17, 53, 74, 75],
  },
  {
    atLeast: 31151,
    notOver: 31200,
    credits: [16, 52, 72, 73],
  },
  {
    atLeast: 31201,
    notOver: 31250,
    credits: [16, 50, 70, 71],
  },
  {
    atLeast: 31251,
    notOver: 31300,
    credits: [15, 49, 68, 69],
  },
  {
    atLeast: 31301,
    notOver: 31350,
    credits: [15, 47, 66, 66],
  },
  {
    atLeast: 31351,
    notOver: 31400,
    credits: [15, 46, 64, 64],
  },
  {
    atLeast: 31401,
    notOver: 31450,
    credits: [14, 44, 62, 62],
  },
  {
    atLeast: 31451,
    notOver: 31500,
    credits: [14, 43, 60, 60],
  },
  {
    atLeast: 31501,
    notOver: 31550,
    credits: [13, 41, 57, 58],
  },
  {
    atLeast: 31551,
    notOver: 31600,
    credits: [13, 40, 55, 56],
  },
  {
    atLeast: 31601,
    notOver: 31650,
    credits: [12, 38, 53, 54],
  },
  {
    atLeast: 31651,
    notOver: 31700,
    credits: [12, 37, 51, 52],
  },
  {
    atLeast: 31701,
    notOver: 31750,
    credits: [11, 35, 49, 49],
  },
  {
    atLeast: 31751,
    notOver: 31800,
    credits: [11, 34, 47, 47],
  },
  {
    atLeast: 31801,
    notOver: 31850,
    credits: [10, 32, 45, 45],
  },
  {
    atLeast: 31851,
    notOver: 31900,
    credits: [10, 31, 43, 43],
  },
  {
    atLeast: 31901,
    notOver: 31950,
    credits: [9, 29, 41, 41],
  },
  {
    atLeast: 31951,
    notOver: 32000,
    credits: [9, 28, 39, 39],
  },
  {
    atLeast: 32001,
    notOver: 32050,
    credits: [9, 26, 36, 37],
  },
  {
    atLeast: 32051,
    notOver: 32100,
    credits: [8, 25, 34, 35],
  },
  {
    atLeast: 32101,
    notOver: 32150,
    credits: [8, 23, 32, 32],
  },
  {
    atLeast: 32151,
    notOver: 32200,
    credits: [7, 22, 30, 30],
  },
  {
    atLeast: 32201,
    notOver: 32250,
    credits: [7, 20, 28, 28],
  },
  {
    atLeast: 32251,
    notOver: 32300,
    credits: [6, 19, 26, 26],
  },
  {
    atLeast: 32301,
    notOver: 32350,
    credits: [6, 17, 24, 24],
  },
  {
    atLeast: 32351,
    notOver: 32400,
    credits: [5, 16, 22, 22],
  },
  {
    atLeast: 32401,
    notOver: 32450,
    credits: [5, 14, 20, 20],
  },
  {
    atLeast: 32451,
    notOver: 32500,
    credits: [4, 13, 18, 17],
  },
  {
    atLeast: 32501,
    notOver: 32550,
    credits: [4, 11, 16, 15],
  },
  {
    atLeast: 32551,
    notOver: 32600,
    credits: [4, 10, 13, 13],
  },
  {
    atLeast: 32601,
    notOver: 32650,
    credits: [3, 8, 11, 11],
  },
  {
    atLeast: 32651,
    notOver: 32700,
    credits: [3, 7, 9, 9],
  },
  {
    atLeast: 32701,
    notOver: 32750,
    credits: [2, 5, 7, 7],
  },
  {
    atLeast: 32751,
    notOver: 32800,
    credits: [2, 4, 5, 5],
  },
  {
    atLeast: 32801,
    notOver: 32850,
    credits: [1, 2, 3, 3],
  },
  {
    atLeast: 32851,
    notOver: 32900,
    credits: [1, 1, 1, 1],
  },
]
